import React from "react";
import i18n from "i18n";
import {
  DashboardOutlined,
  BarChartOutlined,
  TransactionOutlined,
  TrophyOutlined,
  FileTextOutlined,
  DollarOutlined,
  GiftOutlined,
  StarOutlined,
  SafetyCertificateOutlined,
  BellOutlined,
  TeamOutlined,
  PictureOutlined,
  CustomerServiceOutlined,
  ReadOutlined,
  IdcardOutlined,
  ShoppingCartOutlined,
  CoffeeOutlined,
  PlayCircleOutlined,
  MobileOutlined,
  CompassOutlined,
  MedicineBoxOutlined,
  CarOutlined,
  SkinOutlined,
  SolutionOutlined,
  BookOutlined,
  ShopOutlined,
  MessageOutlined,
  BankOutlined,
  FormOutlined,
} from "@ant-design/icons";

export default [
  {
    _to: "/home",
    text: "CMS Admin",
    key: "cms_admin",
    icon: <DashboardOutlined />,
  },
  {
    _to: "/user_activity",
    text: "Thống kê hoạt động",
    key: "user_activity",
    icon: <BarChartOutlined />,
  },
  {
    _to: "/dashboard_stats",
    text: "Thống kê tổng hợp",
    key: "dashboard_stats",
    icon: <BarChartOutlined />,
  },
  {
    _to: "/user_transactions",
    text: "Quản lý giao dịch",
    key: "user_transactions",
    icon: <TransactionOutlined />,
  },
  {
    _to: "/voting",
    text: "Quản lý bình chọn",
    key: "voting",
    icon: <TrophyOutlined />,
    subMenu: [
      {
        key: "contest_list",
        text: "Danh sách cuộc thi",
        _to: "/contest_list",
      },
      {
        key: "candidate_list",
        text: "Danh sách ứng viên",
        _to: "/candidate_list",
      },
      {
        key: "voting_history",
        text: "Lịch sử bình chọn",
        _to: "/voting_history",
      },
    ],
  },
  {
    _to: "/cms_admin_report_manager",
    text: "Quản lý báo cáo",
    key: "cms_admin_report_manager",
    icon: <FileTextOutlined />,
  },
  {
    _to: "/liquid_viego_manager",
    text: "Quản lý thanh khoản Viego",
    key: "liquid_viego_manager",
    icon: <DollarOutlined />,
  },
  {
    _to: "/reward_point_manager",
    text: "Quản lý điểm thưởng",
    key: "reward_point_manager",
    icon: <GiftOutlined />,
  },
  {
    _to: "/comment_and_rating",
    text: "Bình luận & Đánh giá",
    key: "comment_and_rating",
    icon: <StarOutlined />,
  },
  {
    _to: "/identify_user",
    text: "Xác minh danh tính",
    key: "identify_user",
    icon: <SafetyCertificateOutlined />,
  },
  {
    _to: "/system_notifications",
    text: "Thông báo hệ thống",
    key: "system_notifications",
    icon: <BellOutlined />,
  },
  {
    _to: "/cms_admin_manager",
    text: "Quản lý Admin",
    key: "cms_admin_manager",
    icon: <TeamOutlined />,
  },
  {
    _to: "/banners",
    text: "Set Banner",
    key: "banners",
    icon: <PictureOutlined />,
  },
  {
    _to: "/support",
    text: "Hỗ trợ",
    key: "support",
    icon: <CustomerServiceOutlined />,
  },
  {
    key: "news",
    _to: "/news",
    text: i18n.t("menu.news"),
    icon: <ReadOutlined />,
  },
  {
    key: "visa",
    _to: "/visa",
    text: "Visa",
    icon: <IdcardOutlined />,
  },
  {
    _to: "/supermarket",
    text: i18n.t("menu.supermarket"),
    key: "supermarket",
    icon: <ShoppingCartOutlined />,
  },
  {
    _to: "/restaurant",
    text: i18n.t("menu.restaurant"),
    key: "restaurant",
    icon: <CoffeeOutlined />,
  },
  {
    key: "entertainment",
    _to: "/entertainment",
    text: i18n.t("menu.entertainment"),
    icon: <PlayCircleOutlined />,
  },
  {
    key: "sim",
    _to: "/sim",
    text: "Sim",
    icon: <MobileOutlined />,
  },
  {
    key: "travel",
    _to: "/travel",
    text: "Du lịch",
    icon: <CompassOutlined />,
  },
  {
    key: "health",
    _to: "/health",
    text: "Y tế",
    icon: <MedicineBoxOutlined />,
  },
  {
    key: "shipper",
    _to: "/shipper",
    text: "Vận chuyển",
    icon: <CarOutlined />,
  },
  {
    key: "car-and-old-stuff",
    _to: "/car-and-old-stuff",
    text: "Xe - đồ cũ",
    icon: <CarOutlined />,
  },
  {
    key: "cosmetic",
    _to: "/cosmetic",
    text: i18n.t("menu.cosmetic"),
    icon: <SkinOutlined />,
  },
  {
    key: "jobs",
    _to: "/jobs",
    text: i18n.t("menu.jobs"),
    icon: <SolutionOutlined />,
  },
  {
    key: "tutorial",
    text: i18n.t("menu.guideFonehouse"),
    _to: "/guide-fonehouse",
    icon: <BookOutlined />,
  },
  {
    _to: "/cms_viego_support",
    text: "Viego Support",
    key: "cms_viego_support",
    icon: <MessageOutlined />,
    subMenu: [
      {
        key: "viego_messengers",
        text: i18n.t("menu.messengers"),
        _to: "/viego_messengers",
      },
    ],
  },
  {
    text: "Thủ tục Lãnh sự",
    _to: "/consulate",
    key: "consulate",
    icon: <BankOutlined />,
    subMenu: [
      {
        key: "consulate_categories",
        text: "Danh mục",
        _to: "/consulate_categories",
      },
      {
        key: "consulate_messengers",
        text: "Nhắn tin",
        _to: "/consulate_messengers",
      },
    ],
  },
  {
    text: i18n.t("menu.fonehouse"),
    _to: "/fonehouse",
    key: "fonehouse",
    icon: <ShopOutlined />,
    subMenu: [
      {
        key: "list_bill",
        text: i18n.t("menu.list_bill"),
        _to: "/billing_list",
      },
      {
        key: "products",
        text: i18n.t("menu.products"),
        _to: "/products",
      },
      {
        key: "messengers",
        text: i18n.t("menu.messengers"),
        _to: "/messengers",
      },
      {
        key: "checking_insurance",
        text: i18n.t("menu.checking_insurance"),
        _to: "/checking_insurance",
      },
      {
        key: "newsFonehouse",
        text: i18n.t("menu.newsFonehouse"),
        _to: "/news-fonehouse",
      },
      {
        key: "statisticalFonehouse",
        text: i18n.t("menu.statisticalFonehouse"),
        _to: "/statistical-fonehouse",
      },
      {
        key: "moneyManagementFonehouse",
        text: i18n.t("menu.moneyManagementFonehouse"),
        _to: "/moneyManagement-fonehouse",
      },
      {
        key: "historyEditorFonehouse",
        text: i18n.t("menu.historyEditor"),
        _to: "/historyEditor-fonehouse",
      },
      {
        key: "accessories",
        text: i18n.t("menu.accessories"),
        _to: "/accessories",
      },
    ],
  },
  {
    _to: "/registerBusiness",
    text: i18n.t("menu.registerBusiness"),
    key: "registerBusiness",
    icon: <FormOutlined />,
  },
];
